import { useEffect, useState } from 'react';
import { AdminReport, AdminReportsResponse, isType } from '../../shared';
import { fetchReports, UseAdminReports } from './models';

export const useAdminReports = (isLoggedIn: boolean): UseAdminReports => {
  const [reports, setReports] = useState<AdminReport[]>([]);
  const [reportsLoading, setReportsLoading] = useState<boolean>(false);

  useEffect(() => {
    const controller = new AbortController();
    let mounted = true;

    const processfetchReports = async() => {
      setReportsLoading(true);
      const response = await fetchReports(controller);
      if (mounted) {
        if (isType<AdminReportsResponse>(response, 'AdminReportsResponse')) {
          setReports(response.reports);
        }
        setReportsLoading(false);
      }
    };

    if (isLoggedIn) {
      processfetchReports();
    }

    return () => {
      controller.abort();
      mounted = false;
    };
  }, [isLoggedIn]);

  return {reports, reportsLoading};
};

export default useAdminReports;